
import React from "react"
import { Redirect, Route } from "react-router-dom"

const TwoFactorSetupRoute = ({
  component: Component,
  isLoggedin,
  twoFactorChecked,
  twoFactorEnabled,
  onTwoFactorEnabled,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) => {

        if (!isLoggedin) {
          return <Redirect to="/login" />
        }

        if (!twoFactorChecked) {
          return null
        }

        if (twoFactorEnabled === true) {
          return <Redirect to="/" />
        }

        return (
          <Component
            {...props}
            onTwoFactorEnabled={onTwoFactorEnabled}
          />
        )
      }}
    />
  )
}

export default TwoFactorSetupRoute

